export default __webpack_public_path__ + "static/media/link.017d71b5.svg";